// extracted by mini-css-extract-plugin
var _1 = "ProfileCreatedWidgetContent-moduleProfileCreatedWidgetContent__u1UPT";
var _2 = "ProfileCreatedWidgetContent-moduledivider__J1x57 Divider-moduleDivider__dL3Vg";
var _3 = "ProfileCreatedWidgetContent-moduleitem__i07bR ProfileDateWithUserWidgetItem-moduleProfileDateWithUserWidgetItem__oukNF";
export { _1 as "ProfileCreatedWidgetContent", _2 as "divider", _3 as "item" }
